import React, { useEffect, useState, Fragment, createElement } from 'react';
import { Link } from 'react-router-dom';
import { GlobeIcon } from 'lucide-react';
declare global {
  interface Window {
    google: any;
    googleTranslateElementInit: () => void;
  }
}
type LangCode = 'en' | 'fr' | 'es' | 'ar' | 'pt';
const LANGUAGES: {
  code: LangCode;
  label: string;
  aria: string;
}[] = [{
  code: 'en',
  label: 'EN',
  aria: 'Switch to English'
}, {
  code: 'fr',
  label: 'FR',
  aria: 'Changer en français'
}, {
  code: 'es',
  label: 'ES',
  aria: 'Cambiar a español'
}, {
  code: 'ar',
  label: 'AR',
  aria: 'التبديل إلى العربية'
}, {
  code: 'pt',
  label: 'PT',
  aria: 'Mudar para português'
}];
export function TopBar() {
  const [currentLang, setCurrentLang] = useState<LangCode>('en');
  useEffect(() => {
    const existingScript = document.getElementById('google-translate-script');
    if (existingScript) return;
    window.googleTranslateElementInit = () => {
      if (window.google && window.google.translate) {
        new window.google.translate.TranslateElement({
          pageLanguage: 'en',
          includedLanguages: 'en,fr,es,ar,pt',
          autoDisplay: false
        }, 'google_translate_element');
      }
    };
    const script = document.createElement('script');
    script.id = 'google-translate-script';
    script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    script.async = true;
    document.body.appendChild(script);
  }, []);
  const setLanguage = (lang: LangCode) => {
    setCurrentLang(lang);
    // Set document direction for Arabic (RTL)
    document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', lang);
    const triggerChange = () => {
      const select = document.querySelector<HTMLSelectElement>('.goog-te-combo');
      if (select) {
        select.value = lang;
        select.dispatchEvent(new Event('change'));
        return true;
      }
      return false;
    };
    if (!triggerChange()) {
      let attempts = 0;
      const interval = setInterval(() => {
        attempts++;
        if (triggerChange() || attempts > 20) {
          clearInterval(interval);
        }
      }, 200);
    }
  };
  return <div className="bg-charcoal text-white text-sm" data-id="element-316" data-mp="3uk7fcqeddhve">
      <div className="max-w-7xl mx-auto px-4 py-2 flex justify-between items-center gap-4" data-id="element-317" data-mp="3cl7smoj4v99">
        <Link to="/about-au" className="text-xs hover:text-au-gold transition-colors font-medium whitespace-nowrap" data-id="element-318" data-mp="8b65aeced0u0">
          About the African Union
        </Link>
        <div className="flex items-center gap-4" data-id="element-319" data-mp="h3q5vkc91fhh">
          <div className="flex items-center gap-1" data-id="element-320" data-mp="h383s72wo71n">
            <GlobeIcon size={16} className="flex-shrink-0" data-id="element-321" data-mp="m32w8f2bx4ot" />
            {LANGUAGES.map((lang, idx) => <Fragment key={lang.code} data-id="element-322" data-mp="r1e3qj55j33v" data-mpi={idx}>
                {idx > 0 && <span className="text-gray-500" data-id="element-323" data-mp="r272awtyimax">|</span>}
                <button onClick={() => setLanguage(lang.code)} className={`px-2 py-0.5 rounded transition-colors text-xs ${currentLang === lang.code ? 'bg-au-gold text-charcoal font-semibold' : 'hover:text-au-gold'}`} aria-label={lang.aria} data-id="element-324" data-mp="11649l03oerdd">
                  {lang.label}
                </button>
              </Fragment>)}
          </div>
        </div>
        {/* Hidden Google Translate widget mount point */}
        <div id="google_translate_element" style={{
        display: 'none'
      }} data-id="element-325" data-mp="1ewzb1rbui66x"></div>
      </div>
    </div>;
}